<template>
  <div>
    <b-row class="py-2">
      <b-col>{{kontakt.vorname}} {{kontakt.name}}</b-col>
      <b-col>{{kontakt.email}}</b-col>
      <b-col>{{kontakt.mobil}}</b-col>
      <b-col><b-button variant="secondary" v-b-toggle="[`kontakt-${kontakt.id}`]">Bearbeiten</b-button></b-col>
    </b-row>

    <b-collapse :id="`kontakt-${kontakt.id}`" class="mt-2">
      <b-card>
          <div v-if="adminStatus.adminUpdatingContact" class="text-center">
            <b-spinner variant="warning" type="grow"></b-spinner>
          </div>

          <div v-else>
            <b-button variant="outline-secondary" size="sm" class="float-right" v-b-toggle="[`kontakt-${kontakt.id}`]" v-b-tooltip.hover title="Abbrechen">X</b-button>
            <b-form @submit.prevent="kontaktBearbeiten">
              <b-form-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                      :id="`favorit-${kontakt.id}`"
                      v-model="kontakt.favorit"
                      name="favorit"
                      value=1
                      unchecked-value=0
                    >Notfallbenachrichtigungen an diesen Kontakt senden</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col cols="12" sm="6">
                  <b-form-group :id="`geschlecht-group-${kontakt.id}`" label="Anrede" label-for="geschlecht">
                    <b-form-select
                      :id="`geschlecht-${kontakt.id}`"
                      v-model="kontakt.geschlecht"
                      :state="geschlechtState"
                    >
                      <option value="m">Herr</option>
                      <option value="w">Frau</option>
                      <option value="d">Sonstige</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col cols="12" sm="6">
                  <b-form-group :id="`vorname-group-${kontakt.id}`" label="Vorname *" label-for="vorname">
                    <b-form-input
                      :id="`vorname-${kontakt.id}`"
                      v-model="kontakt.vorname"
                      type="text"
                      :state="vornameState"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6">
                  <b-form-group :id="`name-group-${kontakt.id}`" label="Name *" label-for="name">
                    <b-form-input
                      :id="`name-${kontakt.id}`"
                      v-model="kontakt.name"
                      type="text"
                      :state="nameState"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col cols="12" sm="6">
                  <b-form-group :id="`email-group-${kontakt.id}`" label="E-Mail Adresse für Benachrichtigungen" label-for="email">
                    <b-form-input
                      :id="`email-${kontakt.id}`"
                      v-model="kontakt.email"
                      type="email"
                      :state="emailState"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6">
                  <b-form-group :id="`mobil-group-${kontakt.id}`" label="Mobilnummer für Benachrichtigungen" label-for="mobil">
                    <b-form-input :id="`mobil-${kontakt.id}`" v-model="kontakt.mobil" type="text" :state="mobilState"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <hr>

              <b-form-row>
                <b-col>
                  <b-form-group :id="`strass-group-${kontakt.id}`" label="Straße" label-for="strasse">
                    <b-form-input
                      :id="`strasse-${kontakt.id}`"
                      v-model="kontakt.strasse"
                      type="text"
                      :state="strasseState"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group :id="`plz-group-${kontakt.id}`" label="PLZ" label-for="plz">
                    <b-form-input :id="`plz-${kontakt.id}`" v-model="kontakt.plz" type="text" :state="plzState"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group :id="`ort-group-${kontakt.id}`" label="Ort" label-for="ort">
                    <b-form-input :id="`ort-${kontakt.id}`" v-model="kontakt.ort" type="text" :state="ortState"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-group :id="`land-group-${kontakt.id}`" label="Land" label-for="land">
                    <b-form-input :id="`land-${kontakt.id}`" v-model="kontakt.land" type="text" :state="landState"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <hr>

              <b-form-row>
                <b-col>
                  <b-form-group :id="`tel-group-${kontakt.id}`" label="Telefonnummer" label-for="tel">
                    <b-form-input :id="`tel-${kontakt.id}`" v-model="kontakt.tel" type="text" :state="telState"></b-form-input>
                  </b-form-group>

                  <b-form-group :id="`fax-group-${kontakt.id}`" label="Fax" label-for="fax">
                    <b-form-input :id="`fax-${kontakt.id}`" v-model="kontakt.fax" type="text" :state="faxState"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group :id="`telG-group-${kontakt.id}`" label="Telefonnummer Geschäftlich" label-for="telG">
                    <b-form-input :id="`telG-${kontakt.id}`" v-model="kontakt.telG" type="text" :state="telGState"></b-form-input>
                  </b-form-group>

                  <b-form-group :id="`faxG-group-${kontakt.id}`" label="Fax Geschäftlich" label-for="faxG">
                    <b-form-input :id="`faxG-${kontakt.id}`" v-model="kontakt.faxG" type="text" :state="faxGState"></b-form-input>
                  </b-form-group>

                  <b-form-group :id="`mobilG-group-${kontakt.id}`" label="Mobilnummer Geschäftlich" label-for="mobilG">
                    <b-form-input
                      :id="`mobilG-${kontakt.id}`"
                      v-model="kontakt.mobilG"
                      type="text"
                      :state="mobilGState"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    :id="`emailG-group-${kontakt.id}`"
                    label="E-Mail Adresse Geschäftlich"
                    label-for="emailG"
                  >
                    <b-form-input
                      :id="`emailG-${kontakt.id}`"
                      v-model="kontakt.emailG"
                      type="email"
                      :state="emailGState"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <hr>

              <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>

              <b-button
                  v-b-toggle="[`kontakt-${kontakt.id}`]"
                  variant="secondary"
                  class="mr-3"
                >Abbrechen</b-button>
                <b-button variant="danger" @click="kontaktLoeschen">Löschen</b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right"
                  v-bind:disabled="!persoenlichesValidation"
                >Speichern</b-button>
            </b-form>
          </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'BenutzerKontaktBearbeitenRow',
  props: ['kontakt', 'benutzer'],
  computed: {
    ...mapGetters(['adminStatus']),
    geschlechtState() {
      if (this.kontakt.geschlecht === null) {
        return null;
      } else if (
        this.kontakt.geschlecht.toLowerCase() === "m" ||
        this.kontakt.geschlecht.toLowerCase() === "w" ||
        this.kontakt.geschlecht.toLowerCase() === "d"
      ) {
        return true;
      } else {
        return false;
      }
    },
    vornameState() {
      if (this.kontakt.vorname === "") return null;

      return this.kontakt.vorname.length > 2 ? true : false;
    },
    nameState() {
      if (this.kontakt.name === "") return null;

      return this.kontakt.name.length > 2 ? true : false;
    },
    strasseState() {
      if (this.kontakt.strasse === null || this.kontakt.strasse === "")
        return null;

      return this.kontakt.strasse.length > 2 ? true : false;
    },
    plzState() {
      if (this.kontakt.plz === null || this.kontakt.plz === "") return null;

      return this.kontakt.plz.length > 2 ? true : false;
    },
    ortState() {
      if (this.kontakt.ort === null || this.kontakt.ort === "") return null;

      return this.kontakt.ort.length > 2 ? true : false;
    },
    landState() {
      if (this.kontakt.land === null || this.kontakt.land === "") return null;

      return this.kontakt.land.length > 0 ? true : false;
    },
    telState() {
      if (this.kontakt.tel === null || this.kontakt.tel === "") return null;

      return this.kontakt.tel.length > 2 ? true : false;
    },
    faxState() {
      if (this.kontakt.fax === null || this.kontakt.fax === "") return null;

      return this.kontakt.fax.length > 2 ? true : false;
    },
    mobilState() {
      if (this.kontakt.mobil === null || this.kontakt.mobil === "") return null;

      return this.kontakt.mobil.length > 2 ? true : false;
    },
    emailState() {
      if (this.kontakt.email === "") return null;

      return this.emailRegex.test(this.kontakt.email) ? true : false;
    },
    telGState() {
      if (this.kontakt.telG === null || this.kontakt.telG === "") return null;

      return this.kontakt.telG.length > 2 ? true : false;
    },
    faxGState() {
      if (this.kontakt.faxG === null || this.kontakt.faxG === "") return null;

      return this.kontakt.faxG.length > 2 ? true : false;
    },
    mobilGState() {
      if (this.kontakt.mobilG === null || this.kontakt.mobil === "")
        return null;

      return this.kontakt.mobil.length > 2 ? true : false;
    },
    emailGState() {
      if (this.kontakt.emailG === null || this.kontakt.emailG === "")
        return null;

      return this.emailRegex.test(this.kontakt.emailG) ? true : false;
    },
    persoenlichesValidation() {
      return this.vornameState && this.nameState ? true : false
    },
    kontaktinformationValidation() {
      return (this.emailState && this.mobilState) ? true : false
    }
  },
  methods: {
    ...mapActions(['adminUpdateBenutzerKontakt', 'adminDeleteBenutzerKontakt']),
    kontaktBearbeiten() {
      this.adminUpdateBenutzerKontakt({userId: this.benutzer.id, kontakt: this.kontakt}).then(() => {
        const toastData = {
          title: "",
          msg: "Der Kontakt wurde geändert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg.response.data);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`benutzerBearbeiten`);
        // }
      });
    },
    kontaktLoeschen() {
      if (
        confirm("Sind Sie sicher, dass Sie den Kontakt entgülig löschen wollen?")
      ) {
          this.adminDeleteBenutzerKontakt({userId: this.benutzer.id, kontaktId: this.kontakt.id})
            .then(() => {
              const toastData = {
                title: "",
                msg: "Der Kontakt wurde gelöscht.",
                variant: "success"
              };

              if (this.adminStatus.errMsg) {
                (toastData.title = "Es ist etwas schief gelaufen."),
                  (toastData.msg = this.adminStatus.errMsg.response.data);
                toastData.variant = "danger";
              }

              this.$emit("updUserToast", toastData);
            });
      }
    }
  },
  data() {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    };
  }
}
</script>

<style>

</style>